import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'

import Fields from './fields'

export default ({passFieldCount}) => {

  const { template,instanceData, scannerInstanceData } = useContext(PassContext)

  // PAple docs wrong. Limited to a single row for both square and rectangulat barcodes.
//  const barcodeData = dataSelector({template,instanceData, scannerInstanceData,path:"barcode"})
  
//  if (!barcodeData || isSquareBarcode(barcodeData.format)) {
    
    // With square barcodes, secondary and auxillary fields are merged into one line and limited to 4 items
    let maxFields = 4
    
    return (
      <Fields maxFields={maxFields} fieldType="secondary"/>
    )
//  }
/*
  return (
    <>
      <Fields maxFields={passFieldCount.secondary} fieldType="secondary"/>
      <Fields maxFields={passFieldCount.auxiliary} fieldType="auxiliary"/>
    </>
  )
    */
}
/*
const barcodeShapes = {
  PKBarcodeFormatQR : "square",
  PKBarcodeFormatAztec : "square",
  PKBarcodeFormatPDF417 : "linear",
  PKBarcodeFormatCode128 : "linear",
}

const isSquareBarcode = (barcodeType) => {
  return barcodeShapes[barcodeType] === "square"
}
  */